import React from 'react';
import styles from './Components/CSS/BlogsMain.module.css';
import BlogCard from './BlogCard';
import HeroButton from './Banner';
import BookSlider from './BookCategory';
import BottomArea from './BottomArea';
import Footer from '../common/UI/Footer';
import { useHeroSectionsByTypePublic } from '../hooks/herosection/useHeroSectionPublicHooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Loading from '../common/HousGlass Loader/Loading';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Blogs = () => {
    const { heroSections, isLoading: isLoadingHeroSections } = useHeroSectionsByTypePublic('Blog');
    const navigate=useNavigate();
    if (isLoadingHeroSections) {
        return <div className={styles.container}><Loading/></div>;
    }
    
  
  return (
    <>
    <Helmet>
        <title>Blogs - SunoKahaniyan</title>
        <meta name="description" content="Explore our latest blogs on various topics. Stay updated with interesting stories and insights." />
    </Helmet>
    <main className={styles.main}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
    {heroSections && heroSections.length > 0 ? (
        <Swiper
            modules={[Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{
                delay: 3000,
                disableOnInteraction: true,
            }}
            loop={true}
            className={styles.heroSwiper}
        >
            {heroSections?.map(hero => (
                <SwiperSlide key={hero.id} className={styles.heroSwiperSlide}>
                    <div className={styles.heroImageWrapper}>
                        <img
                            src={hero.blog_data.featured_image || 'https://www.w3schools.com/w3images/lights.jpg'}
                            alt={hero.blog_data.title}
                            className={styles.heroImage}
                               onClick={() => {
                                        // Navigation logic
                                        navigate(`/blog/${hero.blog_data.slug}`);
                                    }}
                        />
                      
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    ) : (
        <div className={styles.heroImageWrapper}>
            <img 
                src="./images/Blogs/default-hero-image.png" 
                alt="Default market scene"
                className={styles.heroImage}
            />
            <div className={styles.heroOverlay}>
                <div className={styles.heroContent}>
                    <h1 className={styles.heroTitle}>
                        Welcome to Our Blog
                    </h1>
                    <p className={styles.heroDescription}>
                        Explore interesting topics and stories
                    </p>
                    <button 
                        className={styles.readMoreButton}
                        onClick={() => {
                            console.log('Explore more');
                        }}
                    >
                        Explore More
                    </button>
                </div>
            </div>
        </div>
    )}
</section>

      {/* Blog Cards Section */}
      <section className={styles.blogSection}>
        <h2 className={styles.sectionTitle}>Latest topics</h2>
        <BlogCard />
        
      </section>
      <section>
      <HeroButton />
      <BottomArea />

      <Footer />
      </section>
    </main>
    </>
  );
};

export default Blogs;